import { CUSTOM_ATTRIBUTE_PREFIX } from '../consts';
import { CustomAttribute } from '../types';

export const getSortFieldId = (
  field: string,
  customAttributes: CustomAttribute[],
) => {
  if (!field || field === '') return '';
  const isCustomAttribute = customAttributes.some((attr) => attr.id === field);
  if (!isCustomAttribute) {
    return field.toString();
  }
  const customSortField = CUSTOM_ATTRIBUTE_PREFIX + field;
  return customSortField.toString();
};
